import * as React from 'react';
export const TrackingPropsContext = React.createContext({
    backendTrackingMetaData: { trackingTokens: [], page: '', position: '' },
    entryPoint: '',
    inputHintClick: false,
    interactionTargetUrn: '',
    propChannel: '',
    propSocialInteractionId: '',
    propSourceType: '',
});
//# sourceMappingURL=tracking-props-context.js.map